<template>
  <div class="calculator" :id="calculatorName">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 col-xl-8 mb-3">
          <div class="progress-container">
                    <div class="progress-bar-bg">
                        <div class="progress-bar-fill" :style="{ width: ((currentStep - 1) / (totalSteps - 1)) * 100 + '%' }"></div>
                    </div>
                </div>

                <div class="step-nav-buttons mt-4 text-center">
                    <button
                        type="button"
                        class="btn previous-step"
                        @click="prevStep"
                        v-if="currentStep != 1"
                    >
                        Back
                    </button>
                </div>


				<div class="calculator-container">

					<div class="mt-3" @keyup="resetCalculation" @change="resetCalculation">

						<div v-if="currentStep === 1">
							<h4 class="calc-fieldset-title">Applicant Details</h4>
							<BooleanChoiceButtons
								fieldText="Number of applicants"
								buttonTextLeft="1"
								buttonTextRight="2"		
							>
								<template v-slot:left>
									<input type="radio" v-model="applicantsCount" :value="1">										
								</template>
								<template v-slot:right>
									<input type="radio" v-model="applicantsCount" :value="2">										
								</template>																	
							</BooleanChoiceButtons>
						</div>
					
						<div v-if="currentStep === 2">
							<h4 class="calc-fieldset-title">Applicant Details</h4>
							<InputElement
								fieldText="Applicant 1 annual income (including benefits)?"
							>
								<InputTypeNumber currencyPlaceholder v-model="annualIncome1" />
							</InputElement>
						</div>

						<div v-if="currentStep === 3">
							<h4 class="calc-fieldset-title">Applicant Details</h4>
							<InputElement
								fieldText="Applicant 2 annual income (including benefits)?"
							>
								<InputTypeNumber currencyPlaceholder v-model="annualIncome2" />
							</InputElement>
						</div>

						<div v-if="currentStep === 4">
							<h4 class="calc-fieldset-title">Applicant Details</h4>
							<InputElement					
								fieldText="Number of dependant children?"
							>
								<InputTypeNumber v-model="dependantChildren" />
							</InputElement>
						</div>

						<div v-if="currentStep === 5">
							<h4 class="calc-fieldset-title">Property Details</h4>
							<InputElement					
								fieldText="Value of property:"
							>
								<InputTypeNumber currencyPlaceholder v-model="valueProperty" />
							</InputElement>
						</div>

						<div v-if="currentStep === 6">
							<h4 class="calc-fieldset-title">Property Details</h4>
							<InputElement					
								fieldText="What is the discounted price?"
							>
								<InputTypeNumber currencyPlaceholder v-model="discountedPrice" />
							</InputElement>
						</div>

						<div v-if="currentStep === 7">
							<h4 class="calc-fieldset-title">Property Details</h4>
							<InputElement					
								fieldText="Would you like to put in more deposit from your own resources, if so, how much:"
							>
								<InputTypeNumber currencyPlaceholder v-model="extraDeposit" />
							</InputElement>
						</div>
						
						<div class="row mb-5" v-if="currentStep === 8">
							<div class="col-12 booleanLabel">Why are you using the calculator today?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="I’m ready to get a mortgage"
								>
								<input type="radio" v-model="calcReason1" value="I’m ready to get a mortgage">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="I’m curious to know what I can borrow"
								>
								<input type="radio" v-model="calcReason1" value="I’m curious to know what I can borrow">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="I want to understand what I can afford before I search for a home"
								>
								<input type="radio" v-model="calcReason1" value="I want to understand what I can afford before I search for a home">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div class="row mb-5" v-if="currentStep === 9">
							<div class="col-12 booleanLabel">When are you hoping to move?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="As soon as possible"
								>
								<input type="radio" v-model="calcReason2" value="As soon as possible">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="In the next 3 months"
								>
								<input type="radio" v-model="calcReason2" value="In the next 3 months">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="6-12 months from now"
								>
								<input type="radio" v-model="calcReason2" value="6-12 months from now">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="12+ months from now"
								>
								<input type="radio" v-model="calcReason2" value="12+ months from now">
								</MultiplyChoiceButton>
							</div>
						</div>

						

						<div class="step-nav-buttons mt-4 text-center">
							<button
								type="button"
								class="btn next-step"
								@click="nextStep"
								v-if="currentStep != totalSteps - 1 && currentStep != 10"
								:disabled="!isStepValid"
							>
								Continue
							</button>

							<button
								type="button"
								class="btn calculate"
								v-if="currentStep === totalSteps - 1"
								@click="calculate"
								:disabled="!isStepValid"
							>
								Calculate
							</button>
						</div>

					</div>	
					
					<div v-if="currentStep === 10" ref="resultsContainer">

						<ResultsContainer class="mt-5 mb-5 calc-results-box">
							<div class="mb-3 results-title">{{this.chance}}</div>
						</ResultsContainer>

						<SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody"/>

					</div>

				</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import axios from "axios"

export default {
  components: {
    BooleanChoiceButtons,
		InputElement,
		InputTypeNumber,
		MultiplyChoiceButton,
		ResultsContainer,
		SubmissionForm
  },
  data() {
    return {
      currentStep: 1,
			totalSteps: 10,
      calculatorName: 'right-to-buy-mortgage-calculator',
      applicantsCount: 0,
      annualIncome1: null,
      annualIncome2: null,
      valueProperty: null,
      dependantChildren: null,
      discountedPrice: null,
      extraDeposit: null,
      chance: '',
      calcCompleted: false,
      calculatorReasonTitle: null,
      calculatorReasonResults: null,
      calcReason1: "",
      calcReason2: "",
      listName: "",
      emailAddress: "",
      consent: "",
      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      submissionList: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
      gfid: 6, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
      gfidlist: 9 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    calculate() {
      if (this.currentStep < this.totalSteps) {
				this.currentStep++;
			}
      if( this.totalRequired <= this.householdIncome * 4 ) {
        this.chance =  `You've got a good chance, please submit your details below to obtain your most suitable Right to Buy mortgage advice and the most suitable rates.`;
      }
      if( (this.totalRequired > this.householdIncome * 4) && (this.totalRequired <= this.householdIncome * 5) ) {
        this.chance = `We may be able to get you a Right to Buy Mortgage, please submit your details below to obtain your most suitable Right to Buy mortgage advice and the most suitable rates.`;
      }
      if( (this.totalRequired > this.householdIncome * 5) && (this.totalRequired <= this.householdIncome * 7) ) {
        this.chance = `It's looking difficult, but please submit your details below to obtain your most suitable Right to Buy mortgage advice.`;
      }
      if( this.totalRequired > this.householdIncome * 7 ) {
        this.chance = `It looks unlikely, but please submit your details below to obtain your most suitable Right to Buy mortgage advice.`;
      }
      this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults = 
      `
      Why are you using the calculator today: ${this.calcReason1}
      When will you be ready to move forward: ${this.calcReason2}
      `;
      this.calculatorListName = this.listName;
      this.calculatorEmailAddress = this.emailAddress;
      this.calculatorConsent = this.consent;
      this.$nextTick(() => {
                const resultsContainer = this.$refs.resultsContainer;

                if (resultsContainer) {
                    // Get the bounding rectangle of the element
                    const rect = resultsContainer.getBoundingClientRect();

                    // Calculate the target scroll position
                    const targetScrollPosition = window.scrollY + rect.top - 200;

                    // Scroll to the target position
                    window.scrollTo({
                        top: targetScrollPosition,
                        behavior: 'smooth'
                    });
                } else {
                    console.error('resultsContainer is undefined');
                }
            });
                  var newReasonSubmission = new FormData();
                  var newListSubmission = new FormData();

      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
      newListSubmission.append("input_1", this.calculatorListName);
      newListSubmission.append("input_3", this.calculatorEmailAddress);
      newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/8/submissions', submissionReasonData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionReason = response;
        
        this.submissionReason.is_valid = submissionReason.is_valid;
        this.submissionReason.confirmation_message = submissionReason.confirmation_message;
        this.submissionReason.validation_messages = submissionReason.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/9/submissions', submissionListData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionList = response;
        
        this.submissionList.is_valid = submissionList.is_valid;
        this.submissionList.confirmation_message = submissionList.confirmation_message;
        this.submissionList.validation_messages = submissionList.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
    },
    resetCalculation() {
      this.calcCompleted = false;
    },
    nextStep() {
      if (this.currentStep === 2 && this.applicantsCount === 1) {
        this.currentStep = 4;
      } else if (this.currentStep < this.totalSteps) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep === 2 && this.applicantsCount === '1') {
        this.currentStep = 4;
      } else if (this.currentStep === 10) {
        this.currentStep = 9;
      } else if (this.currentStep < this.totalSteps) {
        this.currentStep--;
      }
    },	
  },
  computed: {
    isStepValid() {
        if (this.currentStep === 1) {
            return this.applicantsCount === 1 || this.applicantsCount === 2;
        }
        if (this.currentStep === 2) {
            return this.annualIncome1 != null;
        }
        if (this.currentStep === 3) {
            return this.annualIncome2 != null;
        }
        if (this.currentStep === 4) {
            return this.dependantChildren != null;
        }
        if (this.currentStep === 5) {
            return this.valueProperty != null;
        }
        if (this.currentStep === 6) {
            return this.discountedPrice != null;
        }
        if (this.currentStep === 7) {
                  return this.extraDeposit != null;
              }
        if (this.currentStep === 8) {
                  return this.calcReason1 != null;
              }
        if (this.currentStep === 9) {
            return this.calcReason2 != null;
        }
        return true;
    },
    showPropertyDetails() {
      return this.householdIncome && (this.dependantChildren || this.dependantChildren === 0);
    },
    showListFields() {
      return this.discountedPrice && (this.extraDeposit || this.extraDeposit === 0)
    },
    showCalculateButton() {
      return this.discountedPrice && (this.extraDeposit || this.extraDeposit === 0)
    },
    householdIncome() {
      let annualIncome1 = this.annualIncome1 ? this.annualIncome1 : 0;
      let annualIncome2 = this.annualIncome2 ? this.annualIncome2 : 0;

      return annualIncome1 + annualIncome2;
    },
    totalRequired() {
      let discountedPrice = this.discountedPrice ? this.discountedPrice : 0;
      let extraDeposit = this.extraDeposit ? this.extraDeposit : 0;

      return discountedPrice - extraDeposit;
    },
    collateMessageBody() {
      const calculatorData = {
        calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
        calculatorResults:
            `
					Number of applicants: ${this.applicantsCount}
					Applicant 1 income: ${parseInt(this.annualIncome1)}
					Applicant 2 income: ${parseInt(this.annualIncome2)}
					Household income: £${this.householdIncome}
                    Number of dependant children: ${parseInt(this.dependantChildren)}
					What is the Right to Buy discounted price? £${parseInt(this.discountedPrice)}
					Deposit amount: £${parseInt(this.extraDeposit)}
                    Total required: £${this.totalRequire}
                    Why are you using the calculator today: ${this.calcReason1}
          When will you be ready to move forward: ${this.calcReason2}
				`
      }

      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
</style>